import $ from "jquery";
import { Component } from "vue-property-decorator";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { VueBase } from "../../Controls/VueBase";
import { Location } from "vue-router/types/router";
import { UtilisateurExterneDto } from "../../../dto/GenApi.iNotPaie.Dto/UtilisateurExterneDto";
import { UtilisateurLightDto } from "../../../dto/GenApi.iNotPaie.Dto/UtilisateurLightDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { UtilisateurOrigineEnum } from "../../../dto/GenApi.iNotPaie.Dto/UtilisateurOrigineEnum";
import { AffichagePlanningUtilisateurEnum } from "../../../dto/GenApi.iNotPaie.Dto/AffichagePlanningUtilisateurEnum";

interface notaireChargeInfos {
    route: string;
    isModified: boolean;
    utilisateurExterne?: UtilisateurExterneDto;
}

@Component
export default class ModalNotaire extends VueBase {
    public dataReady = false;
    public listeCivilite: ParametreDto[] = [];
    public utilisateurExterne?: UtilisateurExterneDto = { Id: 0, EstAffichagePlanningAnonymise: true, Origine: UtilisateurOrigineEnum.UtilisateurExterne, AffichagePlanningEnum: AffichagePlanningUtilisateurEnum.Aucun };
    public notairesChargees: notaireChargeInfos[] = [];
    public listIdCharges: number[] = [];
    public currentId = -1;
    public utilisateurs: UtilisateurLightDto[] = [];

    public Init(id: number): void {
        this.currentId = isNaN(Number(id)) ? -1 : Number(id);

        this.utilisateurExterne = { Id: 0, EstAffichagePlanningAnonymise: true, Origine: UtilisateurOrigineEnum.UtilisateurExterne, AffichagePlanningEnum: AffichagePlanningUtilisateurEnum.Aucun };
        // on a déjà chargé la fiche
        if (this.currentId != -1 && this.notairesChargees[this.currentId] != undefined && this.notairesChargees[this.currentId].isModified) {
            this.utilisateurExterne = this.notairesChargees[this.currentId].utilisateurExterne;
        } else if (this.currentId != -1) {
            // on va la get sur le serveur
            this.dataReady = false;
            ServicesFactoryInstance.UtilisateurExterneService.get(Number(this.currentId), data => {
                this.utilisateurExterne = data;
                this.dataReady = true;
                this.isModified = false;
            }, () => this.dataReady = true);
        } else {
            // cas de la création de base
            this.utilisateurExterne = { Id: -1, EstAffichagePlanningAnonymise: true, Origine: UtilisateurOrigineEnum.UtilisateurExterne, AffichagePlanningEnum: AffichagePlanningUtilisateurEnum.Aucun };
            this.dataReady = true;
            this.isModified = false;
        }
    }

    public onDataChanged(): void {
        this.isModified = true;
    }

    public mounted(): void {
        this.isModified = false;
        this.initConstantes();
    }

    public checkIsModified(location: Location): boolean {
        for (let i = 0; i < this.notairesChargees.length; i++) {
            if (this.listIdCharges[i] == this.currentId) {
                return this.isModified;
            }

            if (this.notairesChargees[this.listIdCharges[i]] != undefined) {
                if (this.notairesChargees[this.listIdCharges[i]].route == location.path) {
                    return this.notairesChargees[this.listIdCharges[i]].isModified;
                }
            } else {
                console.warn("La liste des notaires chargés ne contient pas la clé " + this.listIdCharges[i]);
            }
        }

        return false;
    }

    public saveState(id: number): void {
        const existingSalarie = this.notairesChargees[id];
        const route = existingSalarie != undefined ? existingSalarie.route : this.$router.currentRoute.path;

        this.notairesChargees[id] = { route: route, isModified: this.isModified, utilisateurExterne: this.utilisateurExterne };

        if (this.listIdCharges.filter(n => n == id).length == 0) {
            this.listIdCharges.push(id);
        }
    }

    public closing(location: Location): void {
        super.closing(location);
        for (let i = 0; i < this.listIdCharges.length; i++) {
            const idToClose = this.listIdCharges[i];
            if (this.notairesChargees[idToClose] != undefined) {
                if (this.notairesChargees[idToClose].route == location.path) {
                    if (this.currentId == idToClose) {
                        this.isModified = false;
                    }

                    this.notairesChargees[idToClose].isModified = false;
                }
            } else {
                console.warn("La liste des salariés chargés ne contient pas la clé " + idToClose);
            }
        }
    }

    public initConstantes(): void {
        ServicesFactoryInstance.ParametresService.getCivilites(data => {
            this.listeCivilite = data;
        });

        ServicesFactoryInstance.UtilisateursService.getUtilisateurs(data => {
            this.utilisateurs = data;
        });
    }

    public save(): void {
        if (this.utilisateurExterne != undefined) {
            if (this.utilisateurExterne.AffichagePlanningEnum == 0) {
                NotificationServiceInstance.SendFailed('Le champ "Visibilité du planning" est obligatoire.');
                return;
            }

            this.dataReady = false;
            ServicesFactoryInstance.UtilisateurExterneService.save(this.utilisateurExterne, () => {
                this.dataReady = true;
                this.isModified = false;
                NotificationServiceInstance.SendSuccess((this.utilisateurExterne?.Id == -1 ? "Création" : "Modification") + " de l'utilisateur non salarié effectuée avec succès.");
                this.$emit("update");
                this.annuler();
            }, () => this.dataReady = true);
        }
    }

    public annuler(): void {
        $("#modalNotaire").modal("hide");
    }

    public toggleAnonymisation(): void {
            this.utilisateurExterne!.EstAffichagePlanningAnonymise = !this.utilisateurExterne!.EstAffichagePlanningAnonymise;
    }
}



// WEBPACK FOOTER //
// ./src/components/notaire/modalNotaire/modalNotaire.ts